import { createModule } from 'saga-slice';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as reglementService from '../services/reglementService';

const reglementModule = createModule({
  name: "reglements",
  initialState: {
    list: [],
    loading: false,
    error: null,
    facturesImpayees: [],
    bonLivraisonsNonRegles: [],
    echeances:[],
    cautions:[],
    searchResults: {
      content: [],
      totalElements: 0,
      totalPages: 0,
      number: 0,
      size: 20
    }
  },
  reducers: {
    // List reglements
    listRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    listSuccess: (state, payload) => {
      state.loading = false;
      state.list = payload;
    },
    listEcheanceSuccess: (state, payload) => {
      state.loading = false;
      state.echeances = payload;
    },
    listCautionSuccess: (state, payload) => {
      state.loading = false;
      state.cautions = payload;
    },
    listFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    echeanceClient: (state) => {
      state.loading = true;
      state.error = null;
    },
    cautionClient: (state) => {
      state.loading = true;
      state.error = null;
    },

    // Create reglement
    createRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createSuccess: (state, { payload }) => {
      state.loading = false;
      state.list.push(payload);
    },
    createFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Update reglement
    updateRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateSuccess: (state, { payload }) => {
      state.loading = false;
      const index = state.list.findIndex(item => item.id === payload.id);
      if (index !== -1) {
        state.list[index] = payload;
      }
    },
    updateFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Delete reglement
    deleteRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteSuccess: (state, { payload }) => {
      state.loading = false;
      state.list = state.list.filter(item => item.id !== payload);
    },
    deleteFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Search reglements
    searchRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    searchSuccess: (state, payload ) => {
      state.loading = false;
      state.list = payload;
    },
    searchFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Get reglements by client
    getReglementsByClientRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReglementsByClientSuccess: (state, { payload }) => {
      state.loading = false;
      state.searchResults = payload;
    },
    getReglementsByClientFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Get reglements by invoice
    getReglementsByInvoiceRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReglementsByInvoiceSuccess: (state, { payload }) => {
      state.loading = false;
      state.invoicePayments = payload;
    },
    getReglementsByInvoiceFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Get factures impayees
    getFacturesImpayeesRequest: (state) => {
      state.loading = true;
    },
    getFacturesImpayeesSuccess: (state, { payload }) => {
      state.loading = false;
      state.facturesImpayees = payload;
    },
    getFacturesImpayeesFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    encaisserReglement: (state) => {
      state.loading = true;
      state.error = null;
    },
    encaisserReglementSuccess: (state, payload) => {
      state.loading = false;
      // Update the payment in the list if it exists there
      const index = state.list.findIndex(item => item.id === payload.id);
      if (index !== -1) {
        state.list[index] = payload;
      }
      
    },
    encaisserReglementFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Get bon livraisons non regles
    getBonLivraisonsNonReglesRequest: (state) => {
      state.loading = true;
    },
    getBonLivraisonsNonReglesSuccess: (state, { payload }) => {
      state.loading = false;
      state.bonLivraisonsNonRegles = payload;
    },
    getBonLivraisonsNonReglesFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Add these actions to the reducers object
    linkPaymentsToInvoiceRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    linkPaymentsToInvoiceSuccess: (state, { payload }) => {
      state.loading = false;
      // Update the payments in the list if they exist there
      if (state.list.length > 0) {
        payload.forEach(paymentId => {
          const index = state.list.findIndex(item => item.id === paymentId);
          if (index !== -1) {
            state.list[index].hasInvoice = true;
          }
        });
      }
    },
    linkPaymentsToInvoiceFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
  sagas: (A) => ({
    *[A.listRequest]({ payload }) {
      try {
        const response = yield call(reglementService.getReglements, payload);
        yield put(A.listSuccess(response.data));
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },
    *[A.echeanceClient]({ payload }) {
      try {
        console.log(payload)
        const response = yield call(reglementService.getEcheancesClients, payload);
        console.log(response)
        yield put(A.listEcheanceSuccess(response.data));
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },

    *[A.cautionClient]({ payload }) {
      try {
        const response = yield call(reglementService.getCautionsClients, payload);
        yield put(A.listCautionSuccess(response.data));
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },

    *[A.encaisserReglement]({ payload }) {
      try {
        const { id, dateEncaissement, onSuccess, onError } = payload;
        const response = yield call(
          reglementService.encaisserReglement, 
          id, 
          {dateEncaissement: dateEncaissement}
        );
        yield put(A.encaisserReglementSuccess(response.data));
        if (onSuccess) {
          yield call(onSuccess, response.data);
        }
      } catch (error) {
        yield put(A.encaisserReglementFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.createRequest]({ payload }) {
      try {
        const response = yield call(reglementService.createReglement, payload.data);
        yield put(A.createSuccess(response.data));
        if (payload.onSuccess) {
          payload.onSuccess(response.data);
        }
      } catch (error) {
        yield put(A.createFailure(error.message));
        if (payload.onError) {
          payload.onError(error);
        }
      }
    },

    *[A.getReglementsByInvoiceRequest]({ payload }) {
      try {
        const { numero, onSuccess, onError } = payload;
        const response = yield call(reglementService.getReglementsByInvoice, numero);
        yield put(A.getReglementsByInvoiceSuccess(response.data));
        if (onSuccess) {
          yield call(onSuccess, response.data);
        }
      } catch (error) {
        yield put(A.getReglementsByInvoiceFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.updateRequest]({ payload }) {
      try {
        const response = yield call(reglementService.updateReglement, payload.id, payload.data);
        yield put(A.updateSuccess(response.data));
        if (payload.onSuccess) {
          payload.onSuccess(response.data);
        }
      } catch (error) {
        yield put(A.updateFailure(error.message));
        if (payload.onError) {
          payload.onError(error);
        }
      }
    },

    *[A.deleteRequest]({ payload }) {
      try {
        yield call(reglementService.deleteReglement, payload.id);
        yield put(A.deleteSuccess(payload.id));
        if (payload.onSuccess) {
          payload.onSuccess();
        }
      } catch (error) {
        yield put(A.deleteFailure(error.message));
        if (payload.onError) {
          payload.onError(error);
        }
      }
    },

    *[A.searchRequest]({ payload }) {
      try {
        const response = yield call(reglementService.rechercherReglements, payload);
        yield put(A.searchSuccess(response.data));
      } catch (error) {
        yield put(A.searchFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.getReglementsByClientRequest]({ payload }) {
      try {
        const { clientId, page, size, sortBy, sortDirection, onSuccess, onError } = payload;
        const response = yield call(
          reglementService.getReglementsByClient,
          clientId,
          page,
          size,
          sortBy,
          sortDirection
        );
        yield put(A.getReglementsByClientSuccess(response.data));
        if (onSuccess) {
          yield call(onSuccess, response.data);
        }
      } catch (error) {
        yield put(A.getReglementsByClientFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.getFacturesImpayeesRequest]({ payload }) {
      try {
        const response = yield call(reglementService.getFacturesImpayees, payload);
        yield put(A.getFacturesImpayeesSuccess(response.data));
      } catch (error) {
        yield put(A.getFacturesImpayeesFailure(error.message));
      }
    },

    *[A.getBonLivraisonsNonReglesRequest]({ payload }) {
      try {
        const response = yield call(reglementService.getBonLivraisonsNonRegles, payload);
        yield put(A.getBonLivraisonsNonReglesSuccess(response.data));
      } catch (error) {
        yield put(A.getBonLivraisonsNonReglesFailure(error.message));
      }
    },
  }),
});

export const reglementActions = reglementModule.actions;
export default reglementModule;
